<template>
  <div class="download-button" :class="extraClass" @click="download">
    <component :is="icon"></component>
    <p class="download-button-tagline" v-if="tagline">{{ tagline }}</p>
  </div>
</template>

<script>
import googlePlay from '../../assets/icons/googlePlay';
import payOnline from '../../assets/icons/payOnline';
import appStore from '../../assets/icons/appStore';

export default {
  props: ['icon', 'extraClass', 'tagline'],
  data() {
    return {};
  },
  methods: {
    showModal() {
      this.$store.commit('toggleModal', true);
    },
    download() {
      if (this.icon === 'googlePlay') {
        window.open('https://goo.gl/6t2RQg', '_blank');
      } else {
        this.showModal();
      }
    }
  },
  components: {
    googlePlay,
    payOnline,
    appStore
  }
};
</script>

<style>
.download-button {
  width: 100%;
  height: 91px;
  text-align: center;
  cursor: pointer;
  position: absolute;
  bottom: 0;
  background: #3b3b3b;
  padding-top: 13px;
}
.download-button .download-button-tagline {
  margin: 8px 0 0;
  color: #fff;
  font-size: 11px;
  font-family: 'SF Display Light';
  font-weight: 100;
}
.download-button.google-play,
.download-button.app-store {
  height: 72px;
  width: 310px;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/downloadButton.vue